function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 192l80-10.7c80-10.3 240-32.3 400-26.6 160 5.3 320 37.3 480 16C1120 149 1280 75 1360 37.3L1440 0v320H0z"
});

function SvgWaveinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1440 320"
  }, props), _ref);
}

export default SvgWaveinline;